import {type MutationTree} from 'vuex';

const mutations: MutationTree<ClipboardState> = {
    init(state, className)
    {
        console.log('[Clipboard] Init clipboard ' + className);
        state.selectedItems[className] = [];
    },
    set(state, {className, checkedIds})
    {
        state.selectedItems[className] = JSON.parse(JSON.stringify(checkedIds));
    },
};

export default mutations;